import React, { forwardRef, useImperativeHandle, useState, useRef, useEffect } from 'react';
// redux part
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentYearStudentUIDs } from '../../../store/actions/currentYearStudentUIDActions';

import { Modal } from 'react-bootstrap';
import axios from '../../../interceptor/axios-config';
import { Link } from 'react-router-dom';
import { IMAGES } from '../Dashboard/Content';
import { useGrade } from '../../../context/GradeContext';
import { useFees } from '../../../context/FeeContext';
import { useStudentsData } from '../../../context/StudentsContext';
import { useSfb } from "../../../context/SfbContext";
import Swal from 'sweetalert2';
import Alert from 'react-bootstrap/Alert';
import CaptureModal from './CaptureModal';
import { useSbscData } from '../../../context/SbscContext';
// import WebcamCapture from '../Adminer/WebcamCapture';
import config from '../../../config';
import AutoClosingModal from './AutoClosingModal';
import StudentReceipt from '../Student/StudentReceipt';
import ReactToPrint from 'react-to-print';
import statesWithDistricts from '../../../data/data'; 
import Form from 'react-bootstrap/Form';



const initialFormData = {
    student_uid:'', full_name: '', nationality: 'Indian', religion : 'Christian', pen: '', dob: '', 
    pass_photo: null, class_admitted: '',  sex: '', email: '', place_of_birth: '', 
    admission_status: 'success', father_name: '', mother_name: '', guardian_name: '', aadhar_no: '', 
    r_address: '', state: '', district: '', city: '', pincode: ''
  };

const initialPayData = {
    student_uid:'', net_amt:0, paying_amt:0, balance_amt:0, pay_status:'', app_date:''
}

const EnrollmentModal = forwardRef((props, ref) => { 

    const dispatch = useDispatch();
    const { loading, uids, error } = useSelector((state) => state.currentYearUIDs);

    //Processing state
    const [processing, setProcessing] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');

    useEffect(() => {
        dispatch(fetchCurrentYearStudentUIDs());
    }, [dispatch]);

    // console.log(uids);

    const currentDate = new Date();
    // Format the current date as 'YYYY-MM-DD'
    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

    // for acknowledgement 
    // const [showReceipt, setShowReceipt] = useState(false);
    const receiptRef = useRef(null);
    const printRef = useRef(null);

    // store the entire data for print 
    const [currDetail, setCurrDetail] = useState(initialFormData);
    // console.log(currDetail);

    // state and districts 
    const [selectedState, setSelectedState] = useState('');
    const [districts, setDistricts] = useState([]);

    // Unique ID generator funtion for student uid 
    const generateUniqueID = () => {
        const year = new Date().getFullYear().toString();
        const randomPart = Math.floor(100000 + Math.random() * 900000).toString();
        return year + randomPart;
    };

    //Retry Submit Button auto-click
    const retryButtonRef = useRef(null);

    //This is auto-closing modal
    const [showModal, setShowModal] = useState(false);

    //refresh sbsc data
    const { reloadSbscData} = useSbscData();

    //details for fee-receipt
    const [studentUID, setStudentUID] = useState('');

    // Get Classes API 
    const { grade } = useGrade(); 
    const { feesData } = useFees();
    const { studentsData, refreshData } = useStudentsData();
    const { refetchSfbData } = useSfb();
    const [selectedGrade, setSelectedGrade ]= useState("");
    const [netAmt, setNetAmt]=useState(0);
    const [amtSubtracted, setAmtSubtracted]=useState(netAmt);

    // data for payment receipt
    const [payReceiptData, setPayReceiptData] = useState(initialPayData);

    // This is the student UID 
    const [uniqueID, setUniqueID] = useState(null);

    //For alert message, whether user entered ID exists or not
    const [esms, setEsms] = useState(null)

    //Set Retry submission flag to true
    const [autoRetry, setAutoRetry] = useState(false);

    useEffect(() => {
        if (esms !== null) {
          const timer = setTimeout(() => {
            setEsms(null);
          }, 5000);
          return () => clearTimeout(timer); // Cleanup the timeout on component unmount or formData change
        }
      }, [esms]);

    //Modal
    const [modalBox, setModalBox] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    const [payData, setPayData] = useState(initialPayData);

    // for entry form to check whether entered value is PEN or Student ID 
    const [userEnteredID, setUserEnteredID] = useState('');

    const handleUserEnteredOption = (event) => {
        setUserEnteredID(event.target.value);
    };

    // search by student's PEN No or Unique ID 
    function searchByInput(array, input) {
        let key;
        if (input.length > 10) {
            key = "pen";
        } else if (input.length === 10) {
            key = "student_uid";
        } else {
            return null; // or handle invalid input length
        }
    
        return array.find(obj => obj[key] === input);
    }
    
    
    // let result = searchByInput(studentsData, userEnteredID);
    
    // const handleSearch = () => {
    //     const result = searchByInput(studentsData, userEnteredID);
    //     if (result) {
    //       setFormData(result);
    //       setPayData({...payData,
    //             student_uid:result.student_uid,
    //             app_date:formattedDate
    //       })
    //       setEsms(`Record is found for ${userEnteredID}, Please change the class from the dropdown if promoted to higher class`);
    //     } else {
    //       setEsms(`Record does not exists for ${userEnteredID}, Please got to --> "New Registration"`);
    //     //   console.log("No matching record found");
    //       setFormData(initialFormData); // reset to initial form data if no record found
    //     }
    // };

    const handleSearch = () => {
        // Access the current year's UIDs from Redux
        // const { uids } = useSelector((state) => state.currentYearUIDs);
        
        // Check if the UID already exists for the current academic year

        const uidExists = uids.some(uid => uid.student_uid === userEnteredID);
        // console.log(uidExists)
        // If UID exists in the current year
        if (uidExists === true) {
            setEsms(`Record already exists for ${userEnteredID} for the current academic year.`);
            console.log(esms);
        } else {
            // If UID does not exist, proceed with adding the UID
            const result = searchByInput(studentsData, userEnteredID);
            
            if (result) {
                setFormData(result);
                setPayData({
                    ...payData,
                    student_uid: result.student_uid,
                    app_date: formattedDate
                });
                setEsms(`Record is found for ${userEnteredID}, Please change the class from the dropdown if promoted to higher class`);
            } else {
                setEsms(`Record does not exist for ${userEnteredID}, Please go to "New Registration"`);
                setFormData(initialFormData); // reset to initial form data if no record found
            }
        }
    };
    

    const [selectedOption, setSelectedOption] = useState('');    

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
        setFormData({
            ...formData,
            student_uid: uniqueID
        });
    };

    useEffect(()=>{
        if(selectedOption === 'new-registration'){
            setFormData(initialFormData);
            const timer = setTimeout(() => {
                setFormData({
                    ...formData,
                    student_uid: uniqueID
                });
              }, 1000);
              return () => clearTimeout(timer);            
        }
    },[])

    useEffect(()=>{
        if(uniqueID !== null){
            setFormData({
                ...formData,
                student_uid: uniqueID
            });
        }else{
            const id = generateUniqueID();
            setUniqueID(id);
            setFormData({
                ...formData,
                student_uid: id
            });
        }
    },[uniqueID])

    //capture modal
    const [showCaptureModal, setCaptureModal] = useState(false);

    const handleChildData = (captureFunction) => {
        // Invoke the capture function passed from the child
        const dataFromChild = captureFunction();
        
        // Update parent component state with data from child
        setFormData({
            ...formData,
            pass_photo: dataFromChild
        });
    };

    //To disable submit button base-> on inputs missing i.e total fees
    const [isButtonDisabled, setButtonDisabled] = useState(true);
    const [errMsg, setErrMsg]=useState('');//This will store a message->i.e. Reason for->Why above button is disabled


    //Find out class with fee-structure
    let class_with_fs = [];
    if(feesData.length >0){
        class_with_fs = feesData.map(item => item.grade);
    }
    
    // const searchString = String(selectedGrade);
    const searchString = selectedGrade;
    useEffect(()=>{
        if (selectedGrade !=='' && !class_with_fs.includes(searchString)) {
            // alert(`Class-${selectedGrade} does not have fee-structure yet`);
            setErrMsg(`Class-${selectedGrade} does not have fee-structure yet`);
            setButtonDisabled(true);
          } else {
            setButtonDisabled(false);
            setErrMsg('')
          }
    },[selectedGrade], [class_with_fs], [searchString])

    // type file for image 
    const [file, setFile] = useState(null)


    const handleCapture = () => {
        setCaptureModal(true);
    };
    const closeCaptureModal = () => {
        setCaptureModal(false);
    };

    const onModalClose = () => {
        setSelectedOption('')
        setFormData(initialFormData);
        setPayData(initialPayData);
        setModalBox(false);
    }

    useImperativeHandle(ref, () => ({
        openModal() {         
            setModalBox(true);
        },  
    }));

    
    const handleChange = (e) => {
        const { name, value, type } = e.target;   

        if (type === 'file') {
        // Convert the selected file to Base64
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData({ ...formData, [name]: reader.result });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };
    
    // console.log(formData.student_uid);

    useEffect(()=>{
        if(formData.class_admitted !== initialFormData.class_admitted){
            setSelectedGrade(formData.class_admitted);
        }
    },[formData.class_admitted])
    
    let selectedObj = '';
    if(feesData.length >0){
        selectedObj = feesData.filter(item => item.grade === `${selectedGrade}`);
    }


    const handlePayAmt = (e) =>{
        // Get the current date
        console.log(payData);
        setPayData({...payData,
            student_uid:formData.student_uid,
            net_amt:netAmt, 
            paying_amt:e.target.value, 
            balance_amt:netAmt - e.target.value, 
            pay_status:'Success', 
            app_date:formattedDate
         });
    }
    // console.log(payData);

    useEffect(()=>{
        if(payData.paying_amt > 0){
            const balance = parseInt(netAmt) - parseInt(payData.paying_amt);
            setAmtSubtracted(balance);
        }
    },[payData.paying_amt, netAmt])

    // console.log(amtSubtracted);
    
    useEffect(()=>{
        if(selectedObj.length >0){
            setNetAmt(selectedObj[0].total_fees);
        }
    },[selectedObj]);  

    
    const fileHandler = (e) => {       
        setFile(e.target.files[0]);	

        const { name, value, type } = e.target;   

        if (type === 'file') {
        // Convert the selected file to Base64
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData({ ...formData, [name]: reader.result });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
        } else {
            setFormData({ ...formData, [name]: value });
        }	
    }

    const RemoveFile = () =>{
        setFile(null)
        setFormData({ ...formData, pass_photo:null });
    }
    
    const handleSubmit = async (event) => {
        event.stopPropagation();
    
        let paymentReceipt = payData;
        try {
            if (formData.student_uid !== '') {
                setCurrDetail(formData);
                setStudentUID(formData.student_uid);
    
                // Show spinner with 'Please wait... processing enrollment' message
                setProcessing(true);
                setLoadingMessage('Please wait... processing enrollment');
    
                // First POST request (for student enrollment)
                const firstResponse = await axios.post(
                    `${config.apiBaseUrl}/students/post/addNewStudent.php`,
                    formData
                );
    
                // Hide spinner after first response
                setProcessing(false);
    
                if (firstResponse.data.status === false) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops! Required fields are missing',
                        text: 'Please fill up the required fields and try again',
                        preConfirm: () => {
                            refetchSfbData();
                            setFormData(initialFormData);
                            // setTimeout(() => {
                            //     if (printRef.current) {
                            //         printRef.current.handlePrint();
                            //     }
                            // }, 500);
                        }
                    });
                } else {
                    // Show spinner with 'Confirming payment' message
                    setProcessing(true);
                    setLoadingMessage('Confirming payment');
                    // console.log(payData);
                    // Second POST request (for payment)
                    const secondResponse = await axios.post(
                        `${config.apiBaseUrl}/fees/makePayment.php`,
                        payData
                    );
    
                    // Hide spinner after second response
                    setProcessing(false);
    
                    if (secondResponse.data.status === false) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Payment Failed',
                            text: 'There was an issue with the payment. Please try again later.',
                            preConfirm: () => {
                                return new Promise((resolve) => {
                                    setTimeout(() => {
                                        submitPaymentFailed();
                                        // Optionally, you can reset certain fields here or trigger a refresh
                                        resolve();  // Resolves the Promise after the timeout
                                    }, 1500); // 1.5 seconds delay
                                });
                            }
                        });
                    } else {
                        setPayReceiptData(paymentReceipt);
                        console.log(secondResponse.data);
                        // Final Swal message after both requests are successful
                        Swal.fire({
                            icon: 'success',
                            title: 'Admission successful',
                            text: 'Admission and payment completed successfully!',
                            preConfirm: () => {
                                refetchSfbData();
                                setFormData(initialFormData);
                                setTimeout(() => {
                                    if (printRef.current) {
                                        printRef.current.handlePrint();
                                    }
                                }, 1500);
                            }
                        });
    
                        // Reset form fields after successful admission
                        setFormData({
                            student_uid: '',
                            nationality: 'Indian',
                            religion: '',
                            pen: '',
                            full_name: '',
                            dob: '',
                            pass_photo: null,
                            class_admitted: '',
                            sex: '',
                            email: '',
                            admission_status: '',
                            father_name: '',
                            mother_name: '',
                            guardian_name: '',
                            aadhar_no: '',
                            r_address: '',
                        });
    
                        setPayData({
                            student_uid: '',
                            net_amt: '',
                            paying_amt: '',
                            balance_amt: '',
                            pay_status: '',
                            app_date: '',
                        });
    
                        RemoveFile();
                        setAmtSubtracted(0);
                        setNetAmt(0);
                        setModalBox(false);
                        setUniqueID('');
                        setSelectedOption('');
                        reloadSbscData();
                        refreshData();
                        setAutoRetry(false);
                    }
                }
            } else {
                // Handle case where student_uid is not generated
                setShowModal(true);
                const id = generateUniqueID();
                setFormData({
                    ...formData,
                    student_uid: id
                });

                setPayData({
                    ...payData,
                    student_uid: id
                })
                
                setAutoRetry(true);
            }
        } catch (error) {
            console.error('POST request error:', error);
            setProcessing(false); // Hide spinner on error
            Swal.fire({
                icon: 'error',
                title: 'Oops! Something went wrong',
                text: 'There was an error processing the request. Please try again later.'
            });
        }
    };

    // submit payment failed status function 
    const submitPaymentFailed = async () => {
        try {
          // Update the payData state with the failed status
          const updatedPayData = {
            ...payData,
            pay_status: 'failed'  // Setting the status to 'failed'
          };

        //   console.log(payData);
      
          // Set the updated payData in the state
          setPayData(updatedPayData);
      
          // Submit the updated payment data
          const response = await axios.post(
            `${config.apiBaseUrl}/fees/makePayment.php`,
            updatedPayData
          );
      
          // Handle the response
          if (response.data.status === false) {
            console.log('Payment submission failed on the backend');
            console.log(response.data);
          } else {
            console.log('Payment status updated as failed');
          }
        } catch (error) {
          console.error('Error submitting payment failed status:', error);
        }
      };
    
    

      useEffect(()=>{
        if (autoRetry && retryButtonRef.current) {
            setTimeout(() => {
                // setMessage('Timeout complete!'); // This code will be executed after the timeout/
                retryButtonRef.current.click();
                setShowModal(false);
            }, 3000);            
            setAutoRetry(false);
            }
      },[autoRetry])

      

    return (
        <>
        
        <Modal  onHide={setModalBox} size='xl' show={modalBox} centered> 
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Enrollment Form</h5>
                    <button type="button" className="btn-close"  onClick={onModalClose}></button>
                </div>
                {/* processing  */}
                    {processing && (
                    <div className="spinner-overlay">
                    <div className="spinner-message">
                        <p>{loadingMessage}</p>
                        <div className="spinner"></div> {/* Replace with your spinner */}
                    </div>
                    </div>
                )}
                {errMsg
                    ?(
                        <Alert variant="danger">
                            <Alert.Heading>{errMsg}</Alert.Heading>
                        </Alert>
                    )
                    :''
                }
                <div className="modal-body">
                    <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="container mt-5 mb-4">
                                                <h2>Select an Option</h2>
                                                <form className="d-flex flex-column align-items-start">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="options"
                                                            id="new-registration"
                                                            value="new-registration"
                                                            checked={selectedOption === 'new-registration'}
                                                            onChange={handleOptionChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="new-registration">
                                                            New Registration (New Student ID will be generated)
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="options"
                                                            id="pen-or-suid"
                                                            value="pen-or-suid"
                                                            checked={selectedOption === 'pen-or-suid'}
                                                            onChange={handleOptionChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="pen-or-suid">
                                                            PEN or Student UID (Select this option only if registered previously or PEN No. is available)
                                                        </label>
                                                    </div>
                                                </form>
                                                {esms === `Record already exists for ${userEnteredID} for the current academic year.`
                                                    ?(
                                                        <Alert variant="danger">
                                                            <Alert.Heading>{esms}</Alert.Heading>
                                                        </Alert>
                                                    )
                                                    :''
                                                }
                                                {esms === `Record does not exists for ${userEnteredID}, Please got to --> "New Registration"`
                                                    ?(
                                                        <Alert variant="danger">
                                                            <Alert.Heading>{esms}</Alert.Heading>
                                                        </Alert>
                                                    )
                                                    :''
                                                }
                                                {esms === `Record is found for ${userEnteredID}, Please change the class from the dropdown if promted to higher class`
                                                    ?(
                                                        <Alert variant="success">
                                                            <Alert.Heading>{esms}</Alert.Heading>
                                                        </Alert>
                                                    )
                                                    :''
                                                }

                                                {selectedOption === 'pen-or-suid' && (
                                                    <div className='d-flex p-4'>
                                                        <div className="form-group mt-4 mb-4">
                                                            {/* <label htmlFor="pen-or-suid">PEN or Student UID</label> */}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="pen-or-suid"
                                                                placeholder="Enter PEN or Student UID"
                                                                onChange={handleUserEnteredOption}
                                                            />
                                                        </div>
                                                        <div className="form-group mt-4 mb-4">
                                                            <button type="button" className="btn btn-success light" onClick={handleSearch}>Search</button>
                                                        </div>                                                        
                                                    </div>                                                
                                                )}
                                            </div>

                                        {/* second colum  */}
                                        <div className="col-xl-9 col-lg-8">
                                            <div className="row">
                                             <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput4" className="form-label text-primary">Class<span className="required">*</span></label>
                                                        {/* <input type="text" className="form-control" id="exampleFormControlInput4" placeholder="Wally" /> */}
                                                        <select name="class_admitted" value={formData.class_admitted} onChange={handleChange} className="form-control" id="exampleFormControlInput4" required>
                                                            {grade.map((item) => <option value={item.class_options}>{item.class_label}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Full Name<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput5" 
                                                            name="full_name"
                                                            value={formData.full_name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Father's Name<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput5" 
                                                            name="father_name"
                                                            value={formData.father_name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Mother's Name<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput5" 
                                                            name="mother_name"
                                                            value={formData.mother_name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput6" className="form-label text-primary">Guardian's name<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput6" 
                                                            name="guardian_name"
                                                            value={formData.guardian_name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput6" className="form-label text-primary">Contact Number<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="number" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput6" 
                                                            name="contact_no"
                                                            value={formData.contact_no}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="d-flex mb-3">
                                                        <div className='mb-3'>
                                                            <label htmlFor="exampleFormControlTextarea1" className="form-label text-primary">Nationality<span className="required">*</span></label>
                                                            <input                                                    
                                                                type="text"
                                                                className="form-control"
                                                                id="exampleFormControlTextarea1"
                                                                name="nationality"
                                                                value={formData.nationality} // Bind state to input value
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                        <span className='p-2'></span>
                                                        <div className='mb-3'>
                                                            <label htmlFor="religionSelect" className="form-label text-primary">
                                                            Religion<span className="required">*</span>
                                                            </label>
                                                            <Form.Select size="lg" style={{width:'180px', backgroundColor:'white'}}
                                                                id="religionSelect"
                                                                name="religion"
                                                                value={formData.religion}
                                                                onChange={handleChange}
                                                                required
                                                            >
                                                                <option value="Hindu">Hindu</option>
                                                                <option value="Muslim">Muslim</option>
                                                                <option value="Christian">Christian</option>
                                                                <option value="Sikh">Sikh</option>
                                                                <option value="Buddhist">Buddhist</option>
                                                                <option value="Jain">Jain</option>
                                                                <option value="Other">Other</option>
                                                            </Form.Select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                <div className="mb-3">
                                                        <label  className="form-label text-primary">Date & Place of Birth<span className="required">*</span></label>
                                                        <div className="d-flex">                                                    
                                                            <input                                                     
                                                                type="date" 
                                                                className="form-control" 
                                                                id="exampleFormControlInput7"                                                     
                                                                name="dob"
                                                                value={formData.dob}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                            <input                                                     
                                                                type="text" 
                                                                className="form-control w-50 ms-3" 
                                                                id="exampleFormControlInput7"                                                     
                                                                name="place_of_birth"
                                                                value={formData.place_of_birth}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput1" className="form-label text-primary">Aadhar No<span className="required">*</span></label>
                                                        <input                                                     
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput1"                                                     
                                                            name="aadhar_no"
                                                            value={formData.aadhar_no}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput3" className="form-label text-primary">PEN (Permanent Education Number)<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="number" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput3" 
                                                            name="pen"
                                                            value={formData.pen}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlInput3" className="form-label text-primary">Email<span className="required">*</span></label>
                                                        <input                                                    
                                                            type="email" 
                                                            className="form-control" 
                                                            id="exampleFormControlInput3" 
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="exampleFormControlTextarea1" className="form-label text-primary">Address<span className="required">*</span></label>
                                                        <textarea                                                    
                                                            type="text" 
                                                            className="form-control" 
                                                            id="exampleFormControlTextarea1" 
                                                            rows="1"
                                                            name="r_address"
                                                            value={formData.r_address}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                    {/* updated  */}
                                                    <div className="mb-3">
                                                        <label className="form-label text-primary">
                                                            State & District<span className="required">*</span>
                                                        </label>
                                                        <div className="d-flex">
                                                            <Form.Select
                                                                size="lg"
                                                                style={{ width: '180px', backgroundColor: 'white' }}
                                                                name="state"
                                                                value={formData.state}
                                                                onChange={(e) => {
                                                                    const selectedStateName = e.target.value;
                                                                    setFormData({
                                                                        ...formData,
                                                                        state: selectedStateName,
                                                                        district: '',
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select State</option>
                                                                {statesWithDistricts.map((state) => (
                                                                    <option key={state.name} value={state.name}>
                                                                        {state.name}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Select
                                                                size="lg"
                                                                style={{ width: '180px', backgroundColor: 'white' }}
                                                                name="district"
                                                                value={formData.district}
                                                                onChange={(e) => {
                                                                    const selectedDistrictName = e.target.value;
                                                                    setFormData({
                                                                        ...formData,
                                                                        district: selectedDistrictName,
                                                                    });
                                                                }}
                                                                disabled={!formData.state}
                                                            >
                                                                <option value="">Select District</option>
                                                                {statesWithDistricts
                                                                    .find((state) => state.name === formData.state)
                                                                    ?.districts.map((district) => (
                                                                        <option key={district.name} value={district.name}>
                                                                            {district.name}
                                                                        </option>
                                                                    ))}
                                                            </Form.Select>
                                                        </div>
                                                    </div>


                                                    {/* end  */}
                                                    <div className="mb-3">                                                        
                                                        <div className="d-flex"> 
                                                            <div className='mb-3'>
                                                                <label  className="form-label text-primary">Nearest City<span className="required">*</span></label>                                                   
                                                                <input                                                     
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    id="exampleFormControlInput7"                                                     
                                                                    name="city"
                                                                    value={formData.city}
                                                                    onChange={handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                            <span className='p-2'></span>
                                                            <div className='mb-3'>
                                                                <label  className="form-label text-primary">PINCODE<span className="required">*</span></label>
                                                                <input                                                     
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    id="exampleFormControlInput7"                                                     
                                                                    name="pincode"
                                                                    value={formData.pincode}
                                                                    onChange={handleChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>                                                 
                                                </div>                                                
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-4 d-block">
                                            <div>
                                                <label className="form-label text-primary">Photo<span className="required">*</span></label>
                                                <div className="avatar-upload">
                                                    <div className="avatar-preview">
                                                        {formData.pass_photo === null
                                                            ?(<div id="imagePreview"                                                 
                                                            style={{backgroundImage: file ? "url(" + URL.createObjectURL(file) + ")" : "url(" + IMAGES.noimage +")" }}
                                                            > 			
                                                            </div>
                                                            )
                                                            :(<img src={formData.pass_photo} alt='Student' width={100} />)
                                                        }
                                                    </div>
                                                    <div className="change-btn mt-2 mb-lg-0 mb-3">
                                                        <input type='file' className="form-control d-none" name="pass_photo" onChange={fileHandler}  id="imageUpload" accept=".png, .jpg, .jpeg" />
                                                        <label htmlFor="imageUpload" className="dlab-upload mb-0 btn btn-primary btn-sm">Choose File</label>
                                                        {formData.pass_photo === null
                                                            ?<Link to={"#"} className="btn btn-danger light remove-img ms-2 btn-sm" onClick={handleCapture}>Capture</Link>
                                                            :<Link to={"#"} className="btn btn-danger light remove-img ms-2 btn-sm" onClick={RemoveFile}>Remove</Link>
                                                        }
                                                    </div>
                                                </div>	
                                            </div>
                                            <span className='p-4'></span>
                                            <div className="flex flex-wrap mx-3 mb-1">
                                                <div className="file-input w-full px-9 mb-1 md:mb-0">
                                                <label className="form-label text-primary" htmlFor="grid-first-name">
                                                    Gender
                                                </label>
                                                <div className='flex'>
                                                    <label className="flex form-label text-primary p-2">
                                                    <input
                                                        className='p-4'
                                                        type="checkbox"
                                                        name="sex"
                                                        value="male"
                                                        checked={formData.sex === 'male'}
                                                        onChange={handleChange}
                                                    />
                                                    <span className='p-2'>Male</span>
                                                    </label>
                                                    <span className="p-2"></span>
                                                    <label className="flex form-label text-primary p-2">
                                                    <input
                                                        className='p-4'
                                                        type="checkbox"
                                                        name="sex"
                                                        value="female"
                                                        checked={formData.sex === 'female'}
                                                        onChange={handleChange}
                                                    />
                                                    <span className='p-2'>Female</span>
                                                    </label>
                                                </div>
                                                </div>
                                            </div>
                                            <div>
                                                <label className="form-label text-primary">Net Amount({netAmt})<span className="required">*</span></label>
                                                <input                                                     
                                                    type="number" 
                                                    className="form-control" 
                                                    id="exampleFormControlInput1"  
                                                    value={amtSubtracted === netAmt ? netAmt : amtSubtracted}
                                                    readOnly
                                                />	
                                            </div>
                                            <span className='p-4'></span>
                                            <div>
                                                <label className="form-label text-primary">Paying Amount<span className="required">*</span></label>
                                                <input                                                     
                                                    type="number" 
                                                    className="form-control" 
                                                    id="exampleFormControlInput1"                                                     
                                                    name="paying_amt"
                                                    value={payData.paying_amt}
                                                    onChange={handlePayAmt}
                                                    required
                                                />	
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success light" onClick={handleSubmit} disabled={isButtonDisabled}>Save</button>
                        <button type="button" className="btn btn-danger light" onClick={onModalClose}>Close</button>
                        <button ref={retryButtonRef} onClick={handleSubmit} style={{display:'none'}}>Retry</button>
                    </div>
                    {showModal === true
                        ?(<AutoClosingModal
                        show={true}
                        message="Please wait... generating Unique ID"
                        onClose={() => setShowModal(false)}
                        timeout={3000} // 4 seconds
                        />)
                        :''
                    }
            </div>                
        </Modal>
        {showCaptureModal
            ?(  <CaptureModal 
                    closeCaptureModal={closeCaptureModal} 
                    showCaptureModal={showCaptureModal}
                    handleChildData={handleChildData}
                    />
            )
            :''
        }

        {/* for ack  */}
        <div style={{ display: 'none' }}>
                <StudentReceipt ref={receiptRef} currDetail={currDetail} receiptData={payReceiptData}/>
                <ReactToPrint
                    trigger={() => <button style={{ display: 'none' }}>Hidden Trigger</button>}
                    content={() => receiptRef.current}
                    ref={printRef}
                />
            </div>
    </>
    )
})

export default EnrollmentModal
